module.exports = function normalizeComponent (
 rawScriptExports,
 compiledTemplate,
 scopeId,
 cssModules
) {
 var esModule
 var scriptExports = rawScriptExports = rawScriptExports || {}

 // ES6 modules interop
 var type = typeof rawScriptExports.default
 if (type === 'object' || type === 'function') {
 esModule = rawScriptExports
 scriptExports = rawScriptExports.default
 }

 // Vue.extend constructor export interop
 var options = typeof scriptExports === 'function'
 ? scriptExports.options
 : scriptExports

 // render functions
 if (compiledTemplate) {
 options.render = compiledTemplate.render
 options.staticRenderFns = compiledTemplate.staticRenderFns
 }

 // scopedId
 if (scopeId) {
 options._scopeId = scopeId
 }

 // inject cssModules
 if (cssModules) {
 var computed = options.computed || (options.computed = {})
 Object.keys(cssModules).forEach(function (key) {
 var module = cssModules[key]
 computed[key] = function () { return module }
 })
 }

 return {
 esModule: esModule,
 exports: scriptExports,
 options: options
 }
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/component-normalizer.js
// module id = 85
// module chunks = 0